// eslint-disable-next-line unicorn/filename-case
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export const PhoneE164Validators = (
  control: AbstractControl,
): ValidationErrors | null => {
  const error = Validators.pattern(
    /^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/,
  )(control);
  return error ? { phoneE164: control.value } : null;
};
